<template>
    <el-dialog
            :visible.sync="visible"
            width="900px"
            title="问卷题库"
            @closed="dialogCloseHandler"
            custom-class="question-container">
        <ListLayout class="order-repair-step3-index-wrap">
            <el-form slot="search" :ref="queryFormRef" inline class="search-form" :model="queryFormData"
                     label-width="70px"
                     @submit.native.prevent>

                <el-form-item label="题目名称" prop="title">
                    <el-input type="text" v-model="queryFormData.title" style="width: 250px;"
                              placeholder="填写题目名称进行搜索"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="queryHandler">查询</el-button>
                    <el-button type="info" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table slot="table-list" :ref="tableRef" style="height: 300px" class="background-table" :data="page.list"
                      @select="handleSelection" @select-all="handleSelection">

                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-card class="box-card">
                            <div v-for="item in props.row.paperBackInfoOptions" :key="item.orderNumber"
                                 class="text item">
                                {{'选项' + item.orderNumber }}、{{item.content}}
                            </div>
                        </el-card>
                    </template>
                </el-table-column>

                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column type="index" width="50px"></el-table-column>
                <el-table-column label="题目名称" show-overflow-tooltip width="600px" prop="title"></el-table-column>
                <el-table-column label="题型" show-overflow-tooltip>
                    <template slot-scope="props">
                        <el-tag :type="getType(props.row.type)">{{props.row.typeName}}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </ListLayout>

        <div slot="footer" class="footer-wrap clearFloat">
            <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <el-pagination slot="page" background layout="total, prev, pager, next" :total="page.total"
                               :page-size="page.pageSize"
                               style="text-align: left"
                               :current-page.sync="page.pageNum"
                               @current-change="pageNoToggleHandler"
                               @size-change="pageSizeToggleHandler"></el-pagination>
                <div>
                    <span>已选择<strong>{{selectionNums}}</strong>个题目</span>
                    <el-button class="button-wide" type="danger" @click="addPaper">添加</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default JBoot({

        name: 'questionaireBack',

        componentName: 'questionaireBack',

        registryName: 'questionaireBack',

        data() {
            return {
                moduleName: 'paper',
                listMethod: 'queryPaperTitlePage',
                visible: false,
                selectionRowMap: {},
            }
        },


        computed: {
            selectionNums() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result + (this.selectionRowMap[key] || []).length;
                }, 0);
            },

            submitParams() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result.concat(this.selectionRowMap[key] || []);
                }, []);
            }
        },

        methods: {

            __listInit() {
            },


            __formInit() {
            },


            show() {
                this.visible = true;
                this.queryHandler()
            },

            addPaper() {
                if (this.submitParams.length == 0) {
                    this.$warn('请勾选要添加的题目');
                } else {
                    this.$emit("submitChangeData", this.constructorData(this.submitParams));
                    this.selectionRowMap = {};
                    this.dialogCloseHandler();
                }
            },

            constructorData(params) {
                const props = [];
                let type = this.parentParam.type;
                params.forEach(item => {
                    const prop = {};
                    prop.type = item.type;
                    prop.label = item.title;
                    prop.span = 24;
                    prop.display = true;
                    prop.required = item.required;
                    prop.originLabel = item.title;
                    prop.dicData = [];
                    prop.props = {
                        "label": "label",
                        "value": "value"
                    }
                    prop.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999);
                    if (item.type == 'rate') {
                        prop.showText = true;
                        prop.value = 0;
                        prop.colors = [
                            "#99A9BF",
                            "#F7BA2A",
                            "#FF9900"
                        ];
                    }
                    if (item.paperBackInfoOptions && item.paperBackInfoOptions.length > 0) {
                        if (item.type == 'rate') {
                            prop.texts = [];
                            prop.signs = [];
                            item.paperBackInfoOptions.forEach(item => {
                                prop.texts.push(item.content);
                                if (type == '0') {
                                    prop.signs.push({label: item.content, value: []});
                                } else {
                                    prop.signs.push({
                                        label: item.content,
                                        value: item.otherContent == undefined ? [] : item.otherContent.split(",")
                                    });
                                }
                            })
                        } else {
                            item.paperBackInfoOptions.forEach(item => {
                                prop.dicData.push({label: item.content, value: item.content});
                            })
                        }
                    }
                    props.push(prop);
                })
                return props;
            },

            afterInitPageInfo() {
                this.$nextTick(function () {
                    let tableInstance = this.$getRef(this.tableRef),
                        selectionRows = this.selectionRowMap[this.page.pageNum] || [];

                    if (tableInstance && selectionRows.length > 0) {
                        selectionRows.forEach(item => {
                            this.page.list.filter(ni => ni.id === item.id).forEach(ni => {
                                tableInstance.toggleRowSelection(ni, true);
                            });
                        });
                    }
                });
            },

            getType(type) {
                switch (type) {
                    case "input":
                        return "success";
                    case "radio":
                        return "info";
                    case  "checkbox":
                        return "warning";
                    case "select":
                        return "danger";
                    case "rate":
                        return '';
                }
            },


            dialogCloseHandler() {
                if (this.visible) {
                    this.visible = false;
                } else {
                    this.$closeAllMask();
                    this.resetFormDataInfo();
                }
            },

            handleSelection(selectionRows) {
                this.$set(this.selectionRowMap, this.page.pageNum, [].concat(selectionRows));
            },

            getQueryParam() {
                let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                return {
                    "title:LIKE": this.queryFormData.title == undefined ? undefined : this.queryFormData.title,
                    "infoType:EQ": routeParams.type == undefined ? undefined : routeParams.type
                }
            },

            initPageInfo(response) {
                this.$set(this, 'selectionRowMap', {});
                response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.$set(this, 'page', {
                    list: response.records || [],
                    pageNum: response.current || 0,
                    pageSize: response.size || 10,
                    total: response.total || 0
                })
            },
        }
    }).form().list().build();
</script>

<style lang="scss">
    .question-container {
        & > .el-dialog__body {

            padding: 0 20px;
            min-height: 450px;

            & .el-table__body-wrapper {
                overflow-y: auto;
            }

            .demo-table-expand {
                font-size: 0;
            }

            .demo-table-expand label {
                width: 90px;
                color: #99a9bf;
            }

            .demo-table-expand .el-form-item {
                margin-right: 0;
                margin-bottom: 0;
                width: 50%;
            }

            .el-card__body {
                background: rgb(198, 226, 255);
                padding: 10px !important;
                border-radius: 4px;
            }

            .text {
                font-size: 14px;
            }

            .item {
                padding: 2px 0px;
                margin-left: 10px;
            }

            .box-card {
                width: 100%;
            }


        }

    }
</style>



// WEBPACK FOOTER //
// src/components/QuestionaireBack.vue